import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import WTMonogram from '../components/WTMonogram';
import AuthLegalFooter from '../components/AuthLegalFooter';
import '../styles/login.css';
import { BACKEND_URL } from '../config';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${BACKEND_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || 'Erreur lors de la demande');
      }

      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg" />
      <div className="login-card">
        <div className="login-header">
          <WTMonogram />
          <h1 className="login-title">Webtarot</h1>
          <p className="login-tagline">Réinitialisation du mot de passe</p>
        </div>

        <div className="login-body">
          {sent ? (
            <div className="oauth-callback-content" style={{ padding: '8px 0 0' }}>
              <div className="success-message">
                Si un compte est associé à <strong>{email}</strong>,
                vous recevrez un email avec un lien pour réinitialiser votre mot de passe.
              </div>
            </div>
          ) : (
            <>
              <p className="forgot-intro">
                Entrez l'adresse email associée à votre compte.
                Nous vous enverrons un lien pour réinitialiser votre mot de passe.
              </p>

              <form onSubmit={handleSubmit} className="login-form">
                {error && <div className="login-error">{error}</div>}

                <div className="form-group">
                  <label htmlFor="forgot-email">Adresse email</label>
                  <input
                    type="email"
                    id="forgot-email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="votre@email.com"
                    autoFocus
                    required
                  />
                </div>

                <button type="submit" className="login-button" disabled={loading || !email.includes('@')}>
                  {loading ? 'Envoi...' : 'Envoyer le lien'}
                </button>
              </form>
            </>
          )}

          <div className="login-links">
            <Link to="/">Retour à la connexion</Link>
          </div>

          <AuthLegalFooter />
        </div>
      </div>
    </div>
  );
}

